import { render, staticRenderFns } from "./CodiceAicModalListComponent.vue?vue&type=template&id=1b1f2dd9"
import script from "./CodiceAicModalListComponent.vue?vue&type=script&lang=js"
export * from "./CodiceAicModalListComponent.vue?vue&type=script&lang=js"
import style0 from "./CodiceAicModalListComponent.vue?vue&type=style&index=0&id=1b1f2dd9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports